// utils/formatters.ts
export const isNil = (v) => v === null || v === undefined;
export const isEmptyStr = (v) =>
  typeof v === "string" && v.trim().length === 0;

export const isEmptyValue = (v) => {
  if (isNil(v)) return true;
  if (typeof v === "string") return v.trim() === "" || v === "N/A";
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === "object") return Object.keys(v).length === 0;
  return false;
};

export const formatNumber = (n) => {
  if (isNil(n) || n === "") return "N/A";
  const num = typeof n === "string" ? Number(n) : n;
  if (!Number.isFinite(num)) return String(n);
  return num.toLocaleString("en-US");
};

export const formatCurrency = (n) => {
  if (isNil(n) || n === "") return "N/A";
  const num = typeof n === "string" ? Number(n.replace(/[^0-9.-]/g, "")) : n;
  if (!Number.isFinite(num)) return String(n);
  // Matches your requested "$ 1,000,000" style
  return `$ ${num.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};

export const formatDate = (d) => {
  if (!d) return "N/A";
  const v =
    typeof d === "string"
      ? d
      : typeof d === "object" && "$date" in d
      ? (d.$date)
      : d;
  const dt = new Date(v);
  if (Number.isNaN(dt.getTime())) return String(d);
  return dt.toLocaleDateString("en-US");
};

// Turns snake/camel to "Title Case"
export const prettyLabel = (key) =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (l) => l.toUpperCase());

// Boolean → Y/N for display
export const toYN = (v) => (typeof v === "boolean" ? v ? "Yes" : "No" : v?.toLowerCase() === "y" ? "Yes" : v?.toLowerCase() === "n" ? "No" : "N/A");
